import { UIBrandedFareFeature } from "@flights/types";
import { createTrackingUtils } from "../index";
import { RouteName } from "@flights/constants";

const utils = createTrackingUtils({
  name: "flights_apex_web_show_sellable_seats",
  stages: {
    affected_users: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    sr: 5,
    bf: 6,
    included_and_sellable: 7,
    merged_sellable: 8,
    multi_traveller: 9
  },
  goals: {
    offer_with_sellable_seats: 1,
    offer_has_sellable_seat_no_seatmap: 2,
    seatmap_action_click_with_seat_selected: 3,
    open_check_pay_modal: 4
  },
  defaultStage: 1
});

const trackStages = (
  isMobile: boolean,
  features: UIBrandedFareFeature[],
  multiTraveller: boolean,
  routeName: RouteName
) => {
  const seats = features.filter((feature) => feature.category === "SEATS");

  if (seats.length === 0) return;

  utils.stages.main();

  if (!isMobile) utils.stages.ddot();
  if (isMobile) utils.stages.mdot();
  if (routeName === "searchresults") utils.stages.sr();
  if (routeName === "checkout-fare") utils.stages.bf();
  if (multiTraveller) utils.stages.multi_traveller();

  const includedSeats = new Set(seats.filter((f) => f.availability === "INCLUDED").map((f) => f.featureName));

  if (includedSeats.has("PREMIUM_SEAT")) return;

  const sellableSeats = new Set(seats.filter((f) => f.availability === "SELLABLE").map((f) => f.featureName));

  if (sellableSeats.size > 0) utils.goals.offer_with_sellable_seats();

  if (sellableSeats.has("PREMIUM_SEAT") && sellableSeats.has("BASIC_SEAT")) utils.stages.merged_sellable();

  if (includedSeats.has("BASIC_SEAT") && sellableSeats.has("PREMIUM_SEAT")) {
    utils.stages.included_and_sellable();
    return;
  }

  if (
    includedSeats.size === 1 &&
    includedSeats.has("PRE_RESERVED_SEAT_ASSIGNMENT") &&
    sellableSeats.size === 1 &&
    sellableSeats.has("PRE_RESERVED_SEAT_ASSIGNMENT")
  ) {
    utils.stages.included_and_sellable();
  }
};

export default { ...utils, trackStages };
